import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card shadow-sm h-100 photo-tile photo-tile-upload" }
const _hoisted_2 = { class: "photo-tile-thumb" }
const _hoisted_3 = { class: "text-truncate w-100" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "card-body p-2 small" }
const _hoisted_6 = { class: "text-danger mb-2" }
const _hoisted_7 = {
  key: 1,
  class: "text-success"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.upload.file.type === _ctx.PDF_TYPE)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["d-flex flex-column align-items-center justify-content-center h-100 p-2 text-center text-muted small", {'opacity-50': _ctx.upload.state === 'waiting' || _ctx.upload.state === 'failed'}])
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "far fa-file-pdf fa-3x mb-2" }, null, -1)),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.upload.file.name), 1)
          ], 2))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.upload.previewUrl,
            alt: _ctx.upload.file.name,
            class: _normalizeClass({'opacity-50': _ctx.upload.state === 'waiting' || _ctx.upload.state === 'failed'})
          }, null, 10, _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.upload.state === 'failed')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.upload.error), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary me-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "fas fa-redo me-1" }, null, -1),
              _createTextVNode(" Zkusit znovu ", -1)
            ]))]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('discard')))
            }, " Odebrat ")
          ], 64))
        : (_ctx.upload.state === 'done')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "fas fa-check me-1" }, null, -1),
              _createTextVNode(" Nahráno ", -1)
            ]))]))
          : (_ctx.upload.state === 'uploading')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm me-2 align-middle",
                  role: "status"
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('form.navigation.uploading')) + "… ", 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "fas fa-clock me-1" }, null, -1),
                _createTextVNode(" Čeká na nahrání ", -1)
              ]))]))
    ])
  ]))
}